import { useCallback } from 'react'

import { setDataByPage, useQueryClient } from '@fv/client-core'
import type { FullShipment } from '@fv/client-types'

type RemoveFromListArgs = {
  loadId: string
  queryFilter: string[]
}
export function useRemoveFromList() {
  const queryClient = useQueryClient()

  return useCallback(
    ({ loadId, queryFilter }: RemoveFromListArgs) => {
      queryClient.setQueriesData(
        { queryKey: queryFilter },
        setDataByPage<FullShipment>(data =>
          data.filter(s => s.loadId !== loadId),
        ),
      )
    },
    [queryClient],
  )
}
